/**
 * Boutons "Démarrer rapidement" (ingrédients rapides)
 */

import React from "react";
import { quickStartIngredients } from "../constants/ingredients.js";

export default function QuickStartSection({
  addIngredient,
  getIngredientLabel,
  t,
}) {
  return (
    <div className="mb-4">
      <p className="text-xs font-medium text-ink-600 dark:text-white/80 mb-2">
        {t("suggestionsToStart") || "Démarrer rapidement :"}
      </p>
      <div className="flex flex-wrap gap-2">
        {quickStartIngredients.map((ing) => (
          <button
            key={ing}
            type="button"
            onClick={() => addIngredient(ing)}
            className="px-3 py-1.5 bg-orange-500/20 hover:bg-orange-500/30 text-orange-200 rounded-lg text-sm font-medium border border-orange-400/30 transition-colors"
          >
            + {getIngredientLabel(ing)}
          </button>
        ))}
      </div>
    </div>
  );
}
